import {React, useEffect} from "react";
import { Container, Modal, Row, Col, Button, Form } from "react-bootstrap";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {updateInquiries} from "../../actions/inquiryAction";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const inquiryDataSchema = Yup.object().shape({
  response: Yup.string().required("Remarks field is required"),
});
const InquiryModal = ({ showRolesModal, onHide, inquiryData, currentElement, className}) => {
  const intailValues = {
    name: inquiryData?.name,
    email: inquiryData?.email,
    description: inquiryData?.description,
    issue: inquiryData?.issue,
    response: inquiryData?.response || "",
    status: true,
  }

  const formik = useFormik({
    initialValues: intailValues,
    validationSchema: inquiryDataSchema,
    enableReinitialize: true,
    onSubmit: async (values)=>{   
      try {
        const res = await updateInquiries(inquiryData._id, values);
        if (res?.data?.success) {
          console.log(inquiryData._id)
          if (currentElement) {
            currentElement.innerHTML = `<label class="label label-success m-0">Completed</label>`;
          }
          toast.success(res.data.message);
          
        } else {
          toast.error("An error occurred while updating inquiries.");
        }
      } catch (error) {
        console.error("Error updating inquiries:", error);
        toast.error("Failed to update inquiries. Please try again later.");
      }
      onHide();
    }
   
  });

  useEffect(() => {
    // Function to remove tabindex
    const removeTabIndex = () => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        modalElement.removeAttribute('tabindex');
      }
    };

    // Remove tabindex when modal is shown
    if (showRolesModal) {
      // Small delay to ensure modal is mounted
      setTimeout(removeTabIndex, 0);
    }
  }, [showRolesModal]);
  
  return (
    <Container fluid>
      {inquiryData && (
        <Modal className={`modal-primary ${className}`} show={showRolesModal} onHide={onHide} size="lg">
          <Modal.Header className="justify-content-between">
              <h4 className="mb-0 mb-md-3 mt-0">Inquiry</h4>
              <Button variant="secondary" onClick={onHide}>
                &#10005;
              </Button>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body className="modal-body roles-modal-body">
              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label className="d-block mb-2 text-white">
                      Name:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formik.values.name}
                      readOnly
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label className="d-block mb-2 text-white">
                      Email:
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formik.values.email}
                      readOnly
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label className="d-block mb-2 text-white">
                      Issue:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="issue"
                      value={formik.values.issue}
                      readOnly
                    ></Form.Control>
                  </Form.Group>
                </Col>
               
              </Row>
              <Row>
                <Col lg='12'>
                  <Form.Group>
                    <Form.Label className="d-block mb-2 text-white">
                      Description:
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formik.values.description}
                      readOnly
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg='12'>
                  <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="d-block mb-2 text-white">
                      Remarks:
                    </Form.Label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={
                        formik.values.response
                          ? formik.values.response
                          : ""
                      }
                      content={
                        formik.values.response
                          ? formik.values.response
                          : ""
                      }
                      onChange={(event, editor) =>
                        formik.setFieldValue(
                          "response",
                          editor.getData()
                        )
                      }
                    />
                    {formik.touched.response && formik.errors.response ? (
                      <span
                        className={
                          formik.errors.response ? `` : `d-none`
                        }
                      >
                        <label className="pl-1 text-danger">
                          {formik.errors.response}
                        </label>
                      </span>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                
              </Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <Button variant="secondary" onClick={onHide}>
                  Close
                </Button>
                <Button className="btn-filled" type="submit">
                  Submit
                </Button>
            </Modal.Footer>
          </Form>  
        </Modal>
      )}
    </Container>
  );
};

export default InquiryModal;
